import { FormInput } from "@/components/Inputs/FormInput";
import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { SecondaryButton } from "@/components/Buttons/SecondaryButton";
import { Spacing } from "@/components/Spacing/Spacing";
import { useTranslations } from "next-intl";
import { Link } from "react-router-dom";
import { useRegisterForm } from "./useRegisterForm";

/**
 * Email-first signup — step 1. One field: the email. Submitting sends a magic
 * link; the rest of the form (password + account questions) is filled on
 * /auth/complete-signup after the link is clicked.
 */
export default function RegisterForm() {
  const t = useTranslations("register");
  const {
    email,
    emailError,
    isLoading,
    handleEmailChange,
    handleSubmit,
    rateLimited,
  } = useRegisterForm();

  return (
    <form onSubmit={handleSubmit} noValidate className="w-full">
      {/* L7-REVAL — `noValidate` so the app's OWN validation is what runs.
          Commit 4366f35a switched this email field text→email. The browser's
          native HTML5 email constraint then blocked the form submit BEFORE
          onSubmit→handleSubmit, so validateEmail never ran and the styled,
          translated "Invalid email address" never rendered — the user saw only
          the browser's native bubble, in the BROWSER's locale, unstyled, and
          positioned by the browser.
          Kept as type="email" rather than reverted to text: the type is what
          gives mobile users the @/. keyboard and the right autofill hint. It
          is the native VALIDATION that had to go, not the input type. Every
          form here renders its own `error=` for the field, so nothing is left
          unvalidated. */}
      <p className="body-2-regular font-secondary mb-6">
        {t("emailFirstDescription")}
      </p>

      <FormInput
        key="email"
        id="email"
        type="email"
        inputProps={{ autoCapitalize: "none", autoCorrect: "off", spellCheck: false }}
        value={email}
        autoComplete={true}
        label={t("email")}
        onChangeAction={handleEmailChange}
        error={emailError}
      />

      <Spacing height="h-8" />

      <PrimaryButton
        type="submit"
        text={t("continueWithEmail")}
        size="small"
        disabled={isLoading || rateLimited}
        loading={isLoading}
      />

      <Spacing height="h-3" />

      <Link to="/auth/login">
        <SecondaryButton text={t("alreadyHaveAccount")} size="small" />
      </Link>
    </form>
  );
}
